module.exports = __webpack_public_path__ + "img/icon_logo_signin.5a9e3f05.png";